import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Home from '../components/Home.vue'
import Welcome from '../components/Welcome.vue'
import AdminList from '../components/admin/AdminList.vue'
import RightList from '../components/right/RightList.vue'
import RoleList from '../components/role/RoleList.vue'
import ConfigList from '../components/config/ConfigList.vue'
import CategoryList from '../components/category/CategoryList.vue'
import GroupList from '../components/group/GroupList.vue'
import ContentList from '../components/content/ContentList.vue'
import ContentClassical from '../components/content/ContentClassical.vue'
import ContentAddPage from '../components/content/ContentAddPage.vue'
import ContentRelated from '../components/content/ContentRelated.vue'
import MediaList from '../components/media/MediaList.vue'
import MediaCategoryList from '../components/mediaCategory/MediaCategoryList.vue'
import SubscribeMailList from '../components/subscribe/MailList.vue'
import GhostPostList from '../components/ghost/PostList.vue'
import LabelList from '../components/label/LabelList.vue'
import MailgunList from '../components/mailgun/MailgunList.vue'
import SubscribeOverview from '../components/subscribe/Overview.vue'
import SlideshowList from '../components/slideshow/SlideshowList.vue'
import AuthorList from '../components/author/AuthorList.vue'
import SpecialList from '../components/special/SpecialList.vue'
import SpecialCategoryList from '../components/special/SpecialCategoryList.vue'
import ClassicalList from '../components/classical/ClassicalList.vue'
import CharacteristicColumnList from '../components/characteristic_column/CharacteristicColumnList.vue'
import SpecialSeriesList from '../components/special_series/specialSeriesList.vue'
import SpecialCollectionList from '../components/special_series/specialCollectionList.vue'
import UserConfigList from '../components/user_config/UserConfigList.vue'
import UserList from '../components/user/UserList.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login },
  {
    path: '/home',
    component: Home,
    redirect: '/welcome',
    children: [
      { path: '/welcome', component: Welcome },
      { path: '/admin/list', component: AdminList },
      { path: '/right/list', component: RightList },
      { path: '/role/list', component: RoleList },
      { path: '/config/list', component: ConfigList },
      { path: '/category/list', component: CategoryList },
      { path: '/group/list', component: GroupList },
      { path: '/content/list', component: ContentList },
      { path: '/content/classical_list', component: ContentClassical },
      { path: '/content/add', component: ContentAddPage },
      { path: '/content/related', component: ContentRelated },
      { path: '/media/list', component: MediaList },
      { path: '/media_category/list', component: MediaCategoryList },
      { path: '/mail/list', component: SubscribeMailList },
      { path: '/ghost_post/list', component: GhostPostList },
      { path: '/label/list', component: LabelList },
      { path: '/mailgun/list', component: MailgunList },
      { path: '/sub/overview', component: SubscribeOverview },
      { path: '/slideshow/list', component: SlideshowList },
      { path: '/author/list', component: AuthorList },
      { path: '/special/list', component: SpecialList },
      { path: '/special_category/list', component: SpecialCategoryList },
      { path: '/classical/list', component: ClassicalList },
      { path: '/characteristic_column/list', component: CharacteristicColumnList },
      { path: '/special_collection/list', component: SpecialSeriesList },
      { path: '/special_collection/items', component: SpecialCollectionList },
      // Legacy paths are still stored in the database-driven admin menu.
      { path: '/special_series/list', redirect: '/special_collection/list' },
      { path: '/special_series/collection', redirect: '/special_collection/items' },
      { path: '/user_config/list', component: UserConfigList },
      { path: '/user/list', component: UserList }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

// 路由导航守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login') return next()
  const token = window.sessionStorage.getItem('token')
  if (!token) return next('/login')
  next()
})

export default router
